import { render, staticRenderFns } from "./DrawerColumns.vue?vue&type=template&id=448d1265&scoped=true"
import script from "./DrawerColumns.vue?vue&type=script&lang=ts"
export * from "./DrawerColumns.vue?vue&type=script&lang=ts"
import style0 from "./DrawerColumns.vue?vue&type=style&index=0&id=448d1265&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448d1265",
  null
  
)

export default component.exports